import { render, staticRenderFns } from "./agent-clients-table.vue?vue&type=template&id=7ba95670"
import script from "./agent-clients-table.vue?vue&type=script&lang=js"
export * from "./agent-clients-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports